// extracted by mini-css-extract-plugin
export default {"paragraph":"TestimonialQuote_paragraph__EIWvx"};